// Layer manifest for the illustrated avatars.
//
// Imported one by one rather than through require.context so the files
// resolve under any bundler or test runner, not just webpack. Order does not
// matter here — AvatarSprite decides what gets painted on top of what.

import femaleBackHair from "./female/back_hair.webp";
import femaleTopwear from "./female/topwear.webp";
import femaleNeck from "./female/neck.webp";
import femaleEars from "./female/ears.webp";
import femaleFace from "./female/face.webp";
import femaleNose from "./female/nose.webp";
import femaleEyewhite from "./female/eyewhite.webp";
import femaleEyeiridesL from "./female/eyeirides_l.webp";
import femaleEyeiridesR from "./female/eyeirides_r.webp";
import femaleEyelash from "./female/eyelash.webp";
import femaleEyebrow from "./female/eyebrow.webp";
import femaleMouth0 from "./female/mouth0.webp";
import femaleMouth1 from "./female/mouth1.webp";
import femaleMouth2 from "./female/mouth2.webp";
import femaleMouth3 from "./female/mouth3.webp";
import femaleFrontHair from "./female/front_hair.webp";
import femaleThumb from "./female/thumb.webp";

import maleTopwear from "./male/topwear.webp";
import maleNeck from "./male/neck.webp";
import maleEars from "./male/ears.webp";
import maleFace from "./male/face.webp";
import maleNose from "./male/nose.webp";
import maleEyewhite from "./male/eyewhite.webp";
import maleEyeiridesL from "./male/eyeirides_l.webp";
import maleEyeiridesR from "./male/eyeirides_r.webp";
import maleEyelash from "./male/eyelash.webp";
import maleEyebrow from "./male/eyebrow.webp";
import maleMouth0 from "./male/mouth0.webp";
import maleMouth1 from "./male/mouth1.webp";
import maleMouth2 from "./male/mouth2.webp";
import maleMouth3 from "./male/mouth3.webp";
import maleFrontHair from "./male/front_hair.webp";
import maleThumb from "./male/thumb.webp";

export const SPRITE_LAYERS = {
    female: {
        back_hair: femaleBackHair,
        topwear: femaleTopwear,
        neck: femaleNeck,
        ears: femaleEars,
        face: femaleFace,
        nose: femaleNose,
        eyewhite: femaleEyewhite,
        eyeirides_l: femaleEyeiridesL,
        eyeirides_r: femaleEyeiridesR,
        eyelash: femaleEyelash,
        eyebrow: femaleEyebrow,
        mouth0: femaleMouth0,
        mouth1: femaleMouth1,
        mouth2: femaleMouth2,
        mouth3: femaleMouth3,
        front_hair: femaleFrontHair,
    },
    male: {
        topwear: maleTopwear,
        neck: maleNeck,
        ears: maleEars,
        face: maleFace,
        nose: maleNose,
        eyewhite: maleEyewhite,
        eyeirides_l: maleEyeiridesL,
        eyeirides_r: maleEyeiridesR,
        eyelash: maleEyelash,
        eyebrow: maleEyebrow,
        mouth0: maleMouth0,
        mouth1: maleMouth1,
        mouth2: maleMouth2,
        mouth3: maleMouth3,
        front_hair: maleFrontHair,
    },
};

export const SPRITE_THUMBS = {
    female: femaleThumb,
    male: maleThumb,
};
